<template>
  <div class="dados-privados-details">
    <page-header :title="title" />
    <div class="container">
      <page-section
        v-for="(item, i) in Object.keys(fields)"
        :group-label="$t(item)"
        :key="item + '_' + i"
      >
        <v-layout wrap>
          <div
            class="mb-4 mr-1"
            v-for="(subitem, i) in fields[item]"
            :key="'sub_' + item + '_' + i"
          >
            {{ setCheckedField(item, i) }}
            <v-chip
              small
              class="py-6"
              v-if="subitem.value"
              color="transparent"
              text-color="deep-orange lighten-2"
              dark
              @click="() => showFormWithSelectedRestrictFields(item)"
            >
              <v-layout column>
                <v-layout align-center>
                  <v-icon class="mr-1">mdi-lock</v-icon>
                  <small>{{ $t("restrito") }}</small>
                </v-layout>
                <v-layout style="margin-left: 2px">
                  {{ subitem.label }}
                </v-layout>
              </v-layout>
            </v-chip>
            <v-chip
              v-else
              small
              class="py-6"
              color="transparent"
              text-color="blue lighten-0"
              dark
              @click="() => showFormWithSelectedRestrictFields(item)"
            >
              <v-layout column>
                <v-layout align-center>
                  <v-icon class="mr-1">mdi-earth</v-icon>
                  <small>{{ $t("publico") }}</small>
                </v-layout>
                <v-layout style="margin-left: 2px">
                  {{ subitem.label }}
                </v-layout>
              </v-layout>
            </v-chip>
          </div>
        </v-layout>
      </page-section>
      <Form :title="title" :data="fields" :selected="getFields" />
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/headers/page-header";
import PageSection from "@/components/sections/page-section";
import Form from "./form";
import i18next from "i18next";

const fields = () => ({
  Perfil: [
    { id: 1, key: "fotoPerfil", label: i18next.t("Foto"), value: false },
  ],
  Dados_Pessoais: [
    { id: 1, key: "nome", label: i18next.t("Nome_Completo"), value: false },
    { id: 2, key: "email", label: i18next.t("Email"), value: false },
    { id: 3, key: "dataNasc", label: i18next.t("Data_Nasc"), value: false },
  ],
  Contato_Emergencia: [
    {
      id: 1,
      key: "nomeContato",
      label: i18next.t("Nome_Contato"),
      value: false,
    },
    {
      id: 2,
      key: "emailContato",
      label: i18next.t("Email_Contato"),
      value: false,
    },
    {
      id: 3,
      key: "fone1Contato",
      label: i18next.t("Telefone_1"),
      value: false,
    },
    {
      id: 4,
      key: "fone2Contato",
      label: i18next.t("Telefone_2"),
      value: false,
    },
  ],
  Dados_Fisicos: [
    { id: 1, key: "peso", label: i18next.t("Peso"), value: false },
    { id: 2, key: "altura", label: i18next.t("Altura"), value: false },
  ],
  Dados_Sanguineos: [
    { id: 1, key: "tipoSangue", label: i18next.t("Tipo_Sangue"), value: false },
    {
      id: 2,
      key: "aceitaTransfusaoSangue",
      label: i18next.t("Aceita_Transfusao_Sangue"),
      value: false,
    },
    {
      id: 3,
      key: "doadorOrgaos",
      label: i18next.t("Doador_Orgaos"),
      value: false,
    },
    {
      id: 4,
      key: "usaMedicacaoAntiCoagulo",
      label: i18next.t("medicacao_anti_coagulo"),
      value: false,
    },
  ],
  Medicamentos: [
    {
      id: 1,
      key: "medicamentos",
      label: i18next.t("Medicamentos"),
      value: false,
    },
  ],
  Doencas: [
    { id: 1, key: "doencas", label: i18next.t("Cronicas"), value: false },
  ],
  Alergias: [
    { id: 1, key: "alergias", label: i18next.t("Alergias"), value: false },
  ],
  Cart_Vacinacao: [
    {
      id: 1,
      key: "carteiraVacinacao",
      label: i18next.t("Carteira_Vacinacao"),
      value: false,
    },
    {
      id: 2,
      key: "carteiraConvenio",
      label: i18next.t("Carteira_Convenio"),
      value: false,
    },
    {
      id: 3,
      key: "carteiraDoador",
      label: i18next.t("Carteira_Doador"),
      value: false,
    },
    {
      id: 4,
      key: "carteiraLink",
      label: i18next.t("Carteira_Link"),
      value: false,
    },
  ],
  Prontuario_Medico: [
    {
      id: 1,
      key: "prontuarioMedico",
      label: i18next.t("Prontuario_Medico"),
      value: false,
    },
    { id: 2, key: "numeroSus", label: "Número do SUS", value: false },
  ],
  Medico_Particular: [
    { id: 1, key: "nomeMedico", label: i18next.t("Nome_Medico"), value: false },
    {
      id: 2,
      key: "foneMedico",
      label: i18next.t("Telefone_Medico"),
      value: false,
    },
    {
      id: 3,
      key: "empresaMedico",
      label: i18next.t("Empresa_Comp_Div"),
      value: false,
    },
    { id: 4, key: "observacao", label: i18next.t("Observacao"), value: false },
  ],
  Outras_Informacoes: [
    {
      id: 1,
      key: "informacoes",
      label: i18next.t("Outras_Informacoes"),
      value: false,
    },
  ],
});

export default {
  metaInfo: {
    titleTemplate: (i18next.t("Dados_Privados") || "") + " | %s",
  },
  components: { PageSection, PageHeader, Form },
  data: () => ({
    title: i18next.t("Dados_Privados"),
    fields: { ...fields() },
    select: "",
  }),
  computed: {
    tag() {
      return this.$store.state.tagFuncionario.data || {};
    },
    getFields() {
      const select = this.$store.state.selectedRestrictFields;
      return select ? { [select]: this.fields[select] } : this.fields;
    },
  },
  mounted() {
    // lazy load em caso de recarregamento da página para aguardar as traduções serem carregadas
    setTimeout(() => {
      this.title = i18next.t("Dados_Privados");
      if (!document.title.includes(this.title))
        document.title = this.title + " " + document.title;
      this.fields = fields();
    }, 400);
  },
  methods: {
    setCheckedField(group, fieldIndex) {
      this.fields[group][fieldIndex].value =
        this.tag &&
        this.tag.camposRestritos &&
        this.tag.camposRestritos
          .split(",")
          .some((e) => e === this.fields[group][fieldIndex].key);
    },
    showFormWithSelectedRestrictFields(field) {
      this.$store.commit("setSelectedRestrictFields", field);
      this.$store.commit("setShowModalDataForm", true);
    },
  },
};
</script>

<style lang="scss">
.dados-privados-details {
  .container {
    padding: 0;
    margin: 0;
  }

  @media (min-width: 1025px) {
    .container {
      overflow: hidden auto;
      height: 580px;
      min-height: 580px;
      max-height: 580px;
    }
  }
}
</style>
